// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3G9sg","ranges":"BmiRanges_ranges__1lFCV"};